import React from 'react';
import { Controller } from 'react-hook-form';
import styles from '../stylesheets/selectCards.module.css';

const SelectCards = ({ control, name, options, defaultValue }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <div className={styles.cardContainer}>
          {options.map((item) => {
            const Icon = item?.icon;

            return (
              <div
                key={item.value}
                className={`${styles.card} ${field.value === item.value ? styles.active : ''}`}
                onClick={() => field.onChange(item.value)}
              >
                {Icon && (
                  <div className={styles.icon}>
                    <img src={Icon} className={styles.icon} />
                  </div>
                )}

                <h4 className={styles.title}>{item.label}</h4>

                {item.description && <p className={styles.description}>{item.description}</p>}
              </div>
            );
          })}
        </div>
      )}
    />
  );
};

export default SelectCards;
